import { Link, useNavigate, useParams } from 'react-router-dom';
import './TicketCtrl.scss'
import { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import type { TicketInfo } from '../../common/models/TicketInfo';
import { GoabButton, GoabCircularProgress, GoabIcon } from '@abgov/react-components';
import { TicketDetails } from './ticketDetails/TicketDetails';
import { canShowButton, getTicketRole } from './ticketDetails/role-processor/permission-config';
import { createPageTestId, createNavTestId } from '../../common/utils/testIds';


export function TicketCtrl() {
  const navigate = useNavigate();
  const { ticketId, ticketNumber } = useParams();
  const auth = useAuth();
  
  const [formValues, setFormValues] = useState< Partial<TicketInfo>>();
  const [isEditMode, setIsEditMode] = useState(ticketId === "new");
  
  

  /****************************************************************************************************
   * 
   * @param data 
  *****************************************************************************************************/
  function setTicketInfo(_data: any) {
    setFormValues(_data);
  }
  /****************************************************************************************************
  *****************************************************************************************************/
  useEffect(() => {
    // Update edit mode when ticketId changes
    setIsEditMode(ticketId === "new");
  }, [ticketId]);
  
  /****************************************************************************************************
  *****************************************************************************************************/
  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Main 
  ////////////////////////////////////////////////////////////////////////////////////////////////

  
  return (
    <div className="ticketCtrl-content" data-testid={createPageTestId('ticket-ctrl')}>
      <section className="breadcrumbsSec" data-testid={createNavTestId('breadcrumbs')}>
        <span>
          <Link  data-testid="ticCtrl-page-breadcrumb1" to="/">
            Tickets dashboard
          </Link>
          <GoabIcon size="small" type="arrow-back" data-testid={createNavTestId('breadcrumb-arrow')}></GoabIcon>
          <span data-testid={createPageTestId('ticket-title')}>
            {ticketId === "new" ? "New ticket": formValues?.ticketNumber ?? ticketNumber}
          </span>
        </span>
        {!isEditMode && canShowButton(null, 'create', undefined, getTicketRole(auth)) && <>
           <GoabButton data-testid="edit-ticket-btn" type='primary' size='compact' onClick={() => navigate(`/ticket-ctrl/new`)}>Create new ticket +</GoabButton>
        </>
        }
      </section>
      <TicketDetails 
        data-testid={createPageTestId('ticket-details')} 
        onChange={(data: any) => { setTicketInfo (data) }}
        onEditModeChange={(editMode: boolean) => { setIsEditMode(editMode) }}
      ></TicketDetails>
    </div>
  )
}
